<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>BÖDEN AUS NATURSTEIN</h1>
      <!--   <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Im Außenbereich kennt man Naturstein als Belag für Terrassen, Wege und Einfahrten schon sehr lange. Doch auch im Innenbereich sind Natursteine wie Marmor, Granit, Schiefer, Sand- oder Kalksteine nicht nur auf Grund ihrer individuellen und edlen Optik, sondern auch wegen ihrer praktischen und funktionellen Eigenschaften besonders gut geeignet. Durch moderne Technik ist es uns möglich beinahe jeden Wunsch, was Farbe und Struktur der Steine oder deren Ausarbeitung und Gestaltung betrifft, zu erfüllen. Die Gestaltungsmöglichkeiten eines Natursteinbodens sind somit fast grenzenlos.</p>
        <hr>
        <h2>Natursteinboden – edel und fast unverwüstlich</h2>
        <p>Natursteine sind schadstofffrei, allergikerfreundlich, langlebig, strapazierfähig, nicht brennbar und sehr pflegeleicht. Zudem besitzen Natursteinböden auch eine hervorragende Wärmeleit- und Wärmespeicherfähigkeit, wodurch sie äußerst gut für Fußbodenheizungen geeignet sind. Sie geben die gespeicherte Wärme gleichmäßig ab, wodurch ein angenehmes Raumklima entsteht. Nie mehr kalte Füße!</p>
        <hr>
        <div class="image-row">
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/naturstein-boden-1.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/naturstein-boden-2.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/naturstein-boden-3.jpg"></div>
        </div>
        <hr>
        <h2>Noch keine Ideen? Wir helfen Ihnen!</h2>
        <p>Es gibt tausende Sorten und Arten von Naturstein, Quarzstein und Keramik die sich im gesamten Haus universell einsetzen und mit jedem Wohnstil gut kombinieren lassen. Dennoch besitzt jeder Naturstein unterschiedliche Eignung und Eigenschaften für bestimmte Anwendungen. Lassen Sie sich von der Vielfalt unseres Sortiments inspirieren und <router-link :to="{ name: 'Kontakt' }">genießen Sie eine umfassende Natursteinberatung</router-link>, die standardmäßig zu unseren Serviceleistungen gehört! Zusammen mit Ihnen finden wir den für Sie passenden Naturstein, der Ihren Anforderungen und Wünschen entspricht und Ihren Innenräumen ein besonderes Flair gibt.</p>
      </article>
    </div>
    <hr>
    <div class="image-row">
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/naturstein-boden-4.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/naturstein-boden-5.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/naturstein-boden-6.jpg"></div>
    </div>
    </section>
</template>

<script>
export default {
  name: 'Boeden',
  metaInfo: {
    title: 'Böden aus Naturstein',
    meta:[
      { vmid: 'description', name: 'description', content: "Es gibt tausende Sorten von Naturstein, Quarzstein und Keramik, die sich im gesamten Haus universell einsetzen und mit jedem Wohnstil gut kombinieren lassen."},
      { vmid: 'keywords', name: 'keywords', content: "Natursteinboden, Marmorboden, Granitboden, Natursteinböden, Naturstein Boden, Naturstein Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/naturstein-boden'} ]
  },
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Boeden.vue